import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoSpeedSizeM(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1.2452 1C1.59385 1 1.90636 1.21511 2.03084 1.54078L4.91477 9.08586C4.92827 9.12119 4.96218 9.14453 5 9.14453C5.03782 9.14453 5.07173 9.12119 5.08523 9.08586L7.96916 1.54078C8.09364 1.21511 8.40615 1 8.7548 1C9.35061 1 9.75752 1.60242 9.53504 2.15513L6.22709 10.3734C6.0747 10.752 5.70754 11 5.29942 11H4.70058C4.29246 11 3.9253 10.752 3.77291 10.3734L0.464955 2.15513C0.242481 1.60242 0.649389 1 1.2452 1Z" />
      <path d="M11.9078 6.14682V7.0194H9V6.14682H11.9078ZM9.71789 5H10.91V9.49378C10.91 9.64545 10.9341 9.76179 10.9824 9.84281C11.0329 9.92176 11.0988 9.97578 11.18 10.0049C11.2613 10.034 11.3513 10.0485 11.4501 10.0485C11.5247 10.0485 11.5928 10.0433 11.6542 10.0329C11.7179 10.0225 11.7662 10.0132 11.7991 10.0049L12 10.8868C11.9363 10.9076 11.8452 10.9304 11.7267 10.9554C11.6103 10.9803 11.4676 10.9948 11.2986 10.999C11 11.0073 10.7311 10.9647 10.4918 10.8712C10.2525 10.7756 10.0626 10.6281 9.92206 10.4287C9.78375 10.2292 9.7157 9.97993 9.71789 9.68076V5Z" />
    </svg>
  )
}

export const IconGeoSpeed = createIcon({
  l: IconGeoSpeedSizeM,
  m: IconGeoSpeedSizeM,
  s: IconGeoSpeedSizeM,
  xs: IconGeoSpeedSizeM,
  name: 'IconGeoSpeed',
})
